export default (function (_ref) {
  var text = _ref.text;
  return {
    text: text !== null && text !== void 0 ? text : 'Apply Now',
    vertical: 'Insurance'
  };
});